<script setup>
import axios from 'axios'
import {onMounted, ref, computed} from 'vue'
import {useRoute} from 'vue-router'
import NavBar from '@/components/NavBar'

const eventsURL = 'api/events'
const backEndURL = process.env.VUE_APP_BACKEND_URL

const events = ref([])
const currentEvent = ref(null)

const route = useRoute()
const routeLocal = ref('')

onMounted(async () => {
    routeLocal.value = route.params.link
    events.value = await getEvents()
    await parseData()
    await loadAuthorsIfNeeded()
})

const getEvents = async () => {
    try {
        const res = await axios.get(`${backEndURL}/${eventsURL}`)
        return res.data
    } catch (err) {
        console.error(err)
    }
}

const parseData = async () => {
    const currentRoute = route.params.link
    currentEvent.value = events.value.find(item => item.link === currentRoute)
}

/**
 * If abstract_site_persons already contains full Author objects -> use as is.
 * If it contains IDs -> fetch authors and map IDs to objects.
 */
const authorsById = ref({})
console.log('currentEvent', currentEvent)

const eventAuthors = computed(() => {
    const list = currentEvent.value?.abstract_site_persons || []
    if (!Array.isArray(list) || list.length === 0) return []

    // If backend already gives objects like {id, name, ...}
    if (typeof list[0] === 'object' && list[0] !== null) return list

    // Otherwise assume IDs and map them
    return list.map(id => authorsById.value[id]).filter(Boolean)
})

const loadAuthorsIfNeeded = async () => {
    const list = currentEvent.value?.abstract_site_persons || []
    if (!Array.isArray(list) || list.length === 0) return

    // If already objects, nothing to fetch
    if (typeof list[0] === 'object' && list[0] !== null) return

    // Otherwise fetch all authors once and index by id
    try {
        const res = await axios.get(`${backEndURL}/api/authors`)
        const map = {}
        for (const a of res.data || []) {
            map[a.id] = a
        }
        authorsById.value = map
    } catch (err) {
        console.error(err)
    }
}
</script>

<template>
    <div class="relative">
        <NavBar />

        <div>
            <!-- Page content -->
            <section class="py-16" id="registration">
                <div class="container px-4 mx-auto max-w-3xl" v-if="currentEvent">
                    <a href="https://www.zuerich.com/en" target="_blank">
                        <img
                            width="100"
                            height="100"
                            v-if="routeLocal === 'GuidedCityTour'"
                            class="block w-1/3 h-auto mx-auto mb-6 cursor-pointer"
                            src="/assets/pht/tour.png"
                            alt="" />
                    </a>

                    <div class="max-w-3xl mx-auto text-center">
                        <h1 class="font-heading text-3xl sm:text-4xl mt-2 mb-6">
                            {{ currentEvent.title }}
                        </h1>
                    </div>

                    <!-- Presenter image -->
                    <div v-if="currentEvent.abstract_image" class="flex justify-center mb-8">
                        <img
                            :src="currentEvent.abstract_image"
                            alt="Presenter photo"
                            class="w-48 h-48 object-cover rounded-full shadow-md" />
                    </div>

                    <div
                        class="text-justify"
                        v-if="currentEvent.additional_info"
                        v-html="currentEvent.additional_info"></div>

                    <!--  Speakers cards (centered, after v-html) -->
                    <div v-if="eventAuthors.length" class="mt-12">
                        <!--                        <div class="max-w-3xl mx-auto text-center mb-6">-->
                        <!--                            <h2 class="font-heading text-2xl sm:text-3xl mt-2 uppercase">Speakers</h2>-->
                        <!--                        </div>-->

                        <div class="flex flex-wrap -mx-4 -mb-8 justify-center">
                            <div
                                class="w-full sm:w-1/2 xl:w-1/3 px-4 mb-8"
                                v-for="speaker in eventAuthors"
                                :key="speaker.id || speaker.name">
                                <div class="pt-10 pb-8 px-6 text-center bg-white rounded-md">
                                    <img
                                        class="block mb-8 mx-auto rounded-full object-scale-down h-36 w-38"
                                        :src="
                                            speaker.image
                                                ? speaker.image
                                                : require('@/assets/placeholder.jpg')
                                        "
                                        :alt="speaker.name" />
                                    <h4 class="font-heading leading-7 text-lg font-medium">
                                        {{ speaker.name }}
                                    </h4>
                                    <p v-if="speaker.description" class="leading-7 text-gray-400 mb-6">
                                        {{ speaker.description }}
                                    </p>

                                    <a
                                        v-if="speaker.affiliation_href"
                                        :href="speaker.affiliation_href"
                                        class="text-blue-500"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {{ speaker.affiliation }}
                                    </a>
                                    <p v-else-if="speaker.affiliation" class="text-gray-600">
                                        {{ speaker.affiliation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Speakers cards -->
                </div>
            </section>
        </div>
    </div>
</template>

<style scoped></style>
